import e, { useEffect as b } from "react";
import { useTranslations as f, useKnockClient as x, useKnockSlackClient as L, useSlackAuth as S } from "@knocklabs/react-core";
/* empty css               */
import { SlackIcon as l } from "../SlackIcon/SlackIcon.mjs";
/* empty css            */
const w = (u) => {
  const d = window.screenLeft ?? window.screenX, t = window.screenTop ?? window.screenY, r = window.innerWidth ?? document.documentElement.clientWidth ?? screen.width, c = window.innerHeight ?? document.documentElement.clientHeight ?? screen.height, n = r / 2 - 600 / 2 + d, i = `width=600,height=800,top=${c / 2 - 800 / 2 + t},left=${n}`;
  window.open(u, "Slack OAuth", i);
}, H = ({
  slackClientId: u,
  redirectUrl: h,
  onAuthenticationComplete: s,
  additionalScopes: d
}) => {
  const {
    t
  } = f(), r = x(), {
    setConnectionStatus: c,
    connectionStatus: n,
    setActionLabel: o,
    actionLabel: i,
    errorLabel: _
  } = L(), {
    buildSlackAuthUrl: m,
    disconnectFromSlack: p
  } = S(u, h, d);
  b(() => {
    const k = (a) => {
      if (a.origin === r.host)
        try {
          a.data === "authComplete" && c("connected"), a.data === "authFailed" && c("error"), s && s(a.data);
        } catch {
          c("error");
        }
    };
    return window.addEventListener("message", k, !1), () => {
      window.removeEventListener("message", k);
    };
  }, [r.host, s, c]);
  const g = t("slackDisconnect") || null, E = t("slackReconnect") || null;
  return n === "connecting" || n === "disconnecting" ? /* @__PURE__ */ e.createElement("div", { className: "rsk-connect__button rsk-connect__button--loading" }, /* @__PURE__ */ e.createElement(l, { height: "16px", width: "16px" }), /* @__PURE__ */ e.createElement("span", null, t(n === "connecting" ? "slackConnecting" : "slackDisconnecting"))) : n === "error" ? /* @__PURE__ */ e.createElement("button", { onClick: () => w(m()), className: "rsk-connect__button rsk-connect__button--error", onMouseEnter: () => o(E), onMouseLeave: () => o(null) }, /* @__PURE__ */ e.createElement(l, { height: "16px", width: "16px" }), /* @__PURE__ */ e.createElement("span", { className: "rsk-connect__button__text--error" }, i || _ || t("slackError"))) : n === "disconnected" ? /* @__PURE__ */ e.createElement("button", { onClick: () => w(m()), className: "rsk-connect__button rsk-connect__button--disconnected" }, /* @__PURE__ */ e.createElement(l, { height: "16px", width: "16px" }), /* @__PURE__ */ e.createElement("span", null, t("slackConnect"))) : /* @__PURE__ */ e.createElement("button", { onClick: p, className: "rsk-connect__button rsk-connect__button--connected", onMouseEnter: () => o(g), onMouseLeave: () => o(null) }, /* @__PURE__ */ e.createElement(l, { height: "16px", width: "16px" }), /* @__PURE__ */ e.createElement("span", { className: "rsk-connect__button__text--connected" }, i || t("slackConnected")));
};
export {
  H as SlackAuthButton
};
//# sourceMappingURL=SlackAuthButton.mjs.map
